import { i18n } from "../../Common/_translations";

// Key order is the tab order (PMSLocationDetailSelector maps over it). The
// alarm sits next to the access link: both configure what the guest gets while
// staying, so they read as a pair instead of the alarm hiding among the lists.
export const PMSLocationDetailViewModes = {
    RESERVATIONS        : "RESERVATIONS",
    ACTIVITY            : "ACTIVITY",
    AUDIT               : "AUDIT",
    DEVICES             : "DEVICES",
    INVITATIONS         : "INVITATIONS",
    INTEGRATIONS        : "INTEGRATIONS",
    ALARM               : "ALARM",
    PUBLIC_LINK_DEVICES : "PUBLIC_LINK_DEVICES",
    CONFIGURATION       : "CONFIGURATION",
};

export const viewModeNames = {
    [PMSLocationDetailViewModes.RESERVATIONS]: i18n.t("mod_integrations_reservations_title"),
    [PMSLocationDetailViewModes.ACTIVITY]: i18n.t("global_activity"),
    [PMSLocationDetailViewModes.AUDIT]: i18n.t("common.audit"),
    [PMSLocationDetailViewModes.DEVICES]: i18n.t("global_devices"),
    [PMSLocationDetailViewModes.ALARM]: i18n.t("mod_pms_location_alarm_tab"),
    [PMSLocationDetailViewModes.INVITATIONS]: i18n.t("invitations.invitations"),
    [PMSLocationDetailViewModes.INTEGRATIONS]: i18n.t("mod_integrations_title"),
    [PMSLocationDetailViewModes.PUBLIC_LINK_DEVICES]: i18n.t("mod_pms_location_public_link_devices_tab"),
    [PMSLocationDetailViewModes.CONFIGURATION]: i18n.t("global_settings"),
}

export const PMS_LOCATION_VIEW_MODE_ACTION_TYPES = {
    CHANGE_VIEW_MODE: "CHANGE_VIEW_MODE",
}